module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAMCAYAAABfnvydAAAAAXNSR0IArs4c6QAAAGRJREFUKFPl0LkNAkEURMFqMoAIuDIAm+QxWTLgcnCXBICPRhpjc8Brtcp6qaoRc5yT7KGqBuzwSlV9MMMtyaaDK9b4NlDtxCPJqoM7lm3/EXhPQm17h8s01BMLnJIcOjiiZR9/2IVvrVoTfSgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/zanting.png
// module id = ezby
// module chunks = 1